/* eslint-disable no-use-before-define */
import React, { useEffect, useRef, useState } from "react";
import RemoveIcon from "@material-ui/icons/RemoveCircleOutlineSharp";
import TextField from "@mui/material/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { InputAdornment, makeStyles } from "@material-ui/core";
import { GetStatusResponse } from "../../models/basicInformation.model";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import { prefixer, WEBKIT } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import { useSelector } from "react-redux";

const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

interface MultiSelectCmpPropsType {
  options?: any[];
  onChange?: any;
  label?: string;
  value?: any;
  name?: string;
  id?: string;
  changeMultiSelect?: any;
  responseValue?: string;
  onBlur?: any;
  onSelect?: any;
  disabled?: boolean;
  autocompleteKey?: any;

  defaultValue?: any;
}

let mainColor: any;
const css = `
  .autoCompleteSearchField input {
  margin-top: -5px;
  margin-right: -5px;
}

.autoCompleteSearchField button {

  position: absolute;
  top: -16px;
  left: 10px;
}
  .MuiAutocomplete-clearIndicator{
  margin-left:20px
  }
 

  `;
const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiAutocomplete-inputRoot": {
      overflow: "hidden !important",
      flexWrap: "nowrap !important",
      textOverflow: "ellipsis !important",
      whiteSpace: "nowrap  !important",
      color: "#333",
      position: "initial",
    },
    "& .MuiChip-label": {
      overflow: "inherit !important",
    },
  },
  inputRoot: {
    overflow: "inherit !important",
    "& .MuiAutocomplete-inputRoot": {
      overflow: "hidden !important",
      flexWrap: "nowrap !important",
      textOverflow: "ellipsis !important",
      whiteSpace: "nowrap  !important",
      color: "#333",
    },
    "&.Mui-focused fieldset": {
      borderColor: "green !important",
      borderWidth: "2px !important",
      position: "absolute !important",
    },
  },
  option: {
    '&[aria-selected="true"]': {
      backgroundColor: { mainColor },
    },
    "&:hover": {
      backgroundColor: "#0f8e2c",
    },
    backgroundColor: "#1B3045 !important",
    color: "#fff",
    padding: "12px",
    marginLeft: "2.2vh",
    marginRight: "2.2vh",
    "&:not(:last-child)": {
      borderBottom: ".6px solid rgb(119, 118, 129)",
    },
  },
  paper: {
    backgroundColor: "#1B3045 !important",
    borderRadius: "5px !important ",
  },
}));

export default function AutoCompleteSingleSearch(
  props: MultiSelectCmpPropsType
) {
  const [val, setVal] = useState<any>(props.value || null);

  const classes = useStyles();
  useEffect(() => {
    if (props.value && props.options?.length) {
      const defaultVal = props.options.find(
        (option) => option.id === props.value
      );
      setVal(defaultVal || null);
      if (defaultVal) {
        props.onChange(defaultVal.id, defaultVal.title);
      }
    }
  }, [props.options, props.value]);
  const handleChange = (event: object, value: any) => {
    setVal(value);
    props.onChange(value?.id, value?.title);
  };

  // React.useEffect(() => {
  //   if (props.responseValue && props.responseValue !== val) {
  //     setVal(props.responseValue);
  //   }
  // }, [props.responseValue]);

  const jsonFile = useSelector((state: any) => state.style);
  mainColor = jsonFile?.mainColor;

  return (
    <CacheProvider value={cacheRtl}>
      <style>{css}</style>

      <ThemeProvider theme={theme}>
        <div dir="rtl" className="autoCompleteSearch-container">
          <Autocomplete
            className={jsonFile?.muiColor}
            key={props.autocompleteKey}
            onBlur={props.onBlur}
            onSelect={props.onSelect}
            style={{ position: "inherit", direction: "rtl" }}
            popupIcon={<KeyboardArrowDownIcon />}
            ChipProps={{ deleteIcon: <></> }}
            classes={classes}
            limitTags={1}
            id="single-select"
            filterSelectedOptions
            options={props.options || []}
            onChange={handleChange}
            getOptionLabel={(option) => option.title}
            defaultValue={props.defaultValue}
            value={val || props.defaultValue}
            renderInput={(params) => (
              <TextField
                {...params}
                label={props.label}
                classes={classes}
                color={jsonFile?.muiColor}
                className="autoCompleteSearchField"
              />
            )}
            disableClearable={false}
            disabled={props.disabled}
          />
        </div>
      </ThemeProvider>
    </CacheProvider>
  );
}
